/// <reference types="react/experimental" />

import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <Router>
      <App />
    </Router>
);